import React from 'react';
import UserLookup from './UserLookup';



const UserLookupFormik = ({value,setFieldValue,setFieldTouched,field,placeHolder,searchMethod}) => {
  
    return(
                <UserLookup
                    placeHolder={placeHolder}
                    selectedUser={value} 
                    searchMethod={searchMethod}
                    onUserSelected={value=>{
                        setFieldValue(field,value);
                        setFieldTouched(field);
                    }}
                />
               
            
    );
  }

  export default UserLookupFormik;
